import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Card, Form, Button, Dropdown, InputGroup, FormControl } from 'react-bootstrap';
import { fetchUserBoards, updateFeedItem, addFeedComment, addNewFeed } from '../../../actions/Dashboard/boardsActions';
import { hideModal } from '../../../actions/modalsActions';
import CyberSecurity from '../../../apis/cyberSecurityData';
import history from '../../../history';

//imported comps
import LabelsSelection from './LabelsSelection';
import AddChannel from '../../Pages/Dashboard/sections/boardsSection/AddChannel';
import AddLabel from '../../Pages/Dashboard/sections/boardsSection/AddLabel';

const AddDetails = ({ item, personalTags, boardLabels, channel, feed, mode }) => { //mode addItemFeed || addMessageFeed || editFeed
  console.log(mode)
  //selecting data from redux store
  const currentUser = useSelector(state => state.currentUser);
  const accessToken = useSelector(state => state.accessToken);
  const activeBoard = useSelector(state => state.dashboard_Boards.activeBoard);
  const boards = useSelector(state => state.dashboard_Boards.userBoards);
  const socket = useSelector(state => state.dashboard_socket);
  const dispatch = useDispatch();
  //comp local state
  const [selectedBoard, setSelectedBoard] = useState(boards[0]);
  const [selectedChannel, setSelectedChannel] = useState(channel ? channel : (boards && boards[0] ? boards[0].channels[0] : ''));
  const [selectedBoardLabels, setSelectedBoardlabels] = useState([]);
  const [selectedPersonalTags, setSelectedPersonallabels] = useState(personalTags ? personalTags : []);
  //Form State
  const [noteTitle, setNoteTitle] = useState('');
  const [noteDescription, setNoteDescription] = useState('');
  const [formError, setFormError] = useState('');

  useEffect(() => {
    setSelectedBoard(boards[0])
  }, [boards])

  useEffect(() => {
    dispatch(fetchUserBoards());
  }, [])

  useEffect(() => {
    if (selectedBoard && history.location.pathname !== '/dashboard/boards') getLabels();
  }, [selectedChannel, selectedBoard])

  const getLabels = async () => {
    const feedData = {
      itemId: item._id,
      boardId: selectedBoard._id,
      channel: selectedChannel
    };
    console.log(feedData)
    const response = await CyberSecurity.post('/feeditemlabels', feedData, {
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    })
    setSelectedPersonallabels(response.data)
  }

  const onFormSubmit = async () => {
    if (!selectedBoard) return setFormError('Please Select Board');
    if (!selectedChannel) return setFormError('Please Select Channel');

    setFormError('');

    const record = {
      boardId: selectedBoard._id,
      personalTags: selectedPersonalTags,
      boardLabels: selectedBoardLabels,
      channel: selectedChannel
    }


    if (mode === 'addItemFeed') {

      record.type = 'itemFeed';
      record.noteTitle = noteTitle;
      record.noteDescription = noteDescription;
      record.itemId = item._id;

      //sending the data to backend to create both feed item and comment related to the created feed
      const response = await CyberSecurity.post('/additemtoboard', { ...record }, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })

      console.log(response.data)
      if (history.location.pathname === '/dashboard/boards') {
        if (response.data && response.data.feed) dispatch(updateFeedItem(response.data.feed))
        if (response.data && response.data.comment) dispatch(addFeedComment(response.data.comment))
      }

    }

    else if (mode === 'addMessageFeed') {
      //code here will run if there is no feedId prop (board direct message)
      record.type = 'messageFeed';
      record.message = noteDescription;


      const response = await CyberSecurity.post('/addmessagetoboard', record, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })

      const newMessage = response.data;
      dispatch(addNewFeed(newMessage))
    }

    else if (mode === 'editFeed') {
      record.noteDescription = noteDescription;
      record.feedId = feed._id

      const response = await CyberSecurity.post('/editfeed', record, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })

      if (response.data && response.data.feed) dispatch(updateFeedItem(response.data.feed))
      if (response.data && response.data.comment) dispatch(addFeedComment(response.data.comment))
    }

    //emitting a message to board members
    // socket.emit('message', activeBoard);
    // socket.emit('itemFeed', { item: response.data, board: activeBoard });
    dispatch(hideModal());
  }

  return (
    <div>

      <div>
        <Row>
          <Col md={8} className="pr-md-4 pt-3">
            <label className="form-label label--uppercase">Send to</label>
            <span className="d-block form-info-text text-md">My personal board</span>

            {item && <div className="shared-block">
              <Row>
                <Col md={8}>
                  <div>
                    <h3 className="mb-0 p-3">{item.title}</h3>
                  </div>
                </Col>

                <Col md={4}>
                  <img src={item.image} alt="" className="shared-block__img" />
                </Col>
              </Row>
            </div>}

            <Form.Group className="mt-3">
              <Form.Label><span className="label--uppercase">Add note</span></Form.Label>
              <Form.Control value={noteDescription} onChange={(e) => setNoteDescription(e.target.value)} as="textarea" rows="4" placeholder="Include a note with this item (optional)" />
            </Form.Group>

            <p className="text-red">{formError}</p>

            <div className="d-flex justify-content-center py-4">
              <Button variant="primary" size="lg" className="w-100" onClick={onFormSubmit}>
                Send to my board
              </Button>
            </div>

          </Col>

          <Col className="px-md-4 modal-right-sidebar" md={4}>

            {history.location.pathname !== '/dashboard/boards' && <div className="mt-4">
              <div className="d-flex justify-content-between" >
                <span className="mb-3 form-label label--uppercase">Channels</span>
                {selectedBoard && selectedBoard.owner === currentUser._id && <AddChannel activeBoard={selectedBoard} />}
              </div>
              <ul className="channels-list">
                {selectedBoard && selectedBoard.channels && selectedBoard.channels.length > 0 && selectedBoard.channels.map(channel => {
                  return <li key={channel} className={selectedChannel === channel ? 'selected' : ''} onClick={() => setSelectedChannel(channel)}># {channel}</li>
                })}
              </ul>
            </div>}

            {/* Personal Labels Section */}
            {selectedBoard && <LabelsSelection board={selectedBoard}
              selectedBoardLabels={selectedBoardLabels}
              setSelectedBoardlabels={setSelectedBoardlabels}
              selectedPersonalTags={selectedPersonalTags}
              setSelectedPersonallabels={setSelectedPersonallabels}
            />}

          </Col >
        </Row>
      </div>
    </div>
  )
}

export default AddDetails
